export default __webpack_public_path__ + "47d41fcd69ae31e86417ba9badb767d6.webp";